// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Container from '../../container/container';

// Styles
import NoticeStyles from './notice.styles';

export default function Notice({ layout }) {
  const heading = layout?.heading;
  const bgColor = layout?.backgroundColour;

  if (!heading) return '';

  return (
    <NoticeStyles bgColor={bgColor}>
      <Container>
        <div className="inner">
          <h3 className="heading">{heading}</h3>
        </div>
      </Container>
    </NoticeStyles>
  );
}

Notice.propTypes = {
  layout: PropTypes.shape({
    heading: PropTypes.string,
    backgroundColour: PropTypes.string,
  }),
};

Notice.defaultProps = {
  layout: {},
};
